import { z } from 'zod'
import { guideLevelSettingsSchema, versionLevelSettingsSchema } from './shared'

export const apiReferenceVersionSchema = z.object({
	settings: versionLevelSettingsSchema.extend({
		url: z.string(),
	}),
})

// API Reference Schema
export const apiReferenceSchema = z.object({
	variant: z.literal('API_REFERENCE'),
	settings: guideLevelSettingsSchema,
})

export const apiReferenceSchemaWithVersions = apiReferenceSchema.extend({
	versions: z.array(apiReferenceVersionSchema),
})
export type ParsedAPIReferenceVersionConfig = z.infer<typeof apiReferenceVersionSchema>
